module.exports = __webpack_public_path__ + "static/media/33_KenanDemir_webfinal.fe56d172.jpg";